import { Modal } from "components/common"
import { ActiveShipmentsContext, DocumentsContext } from "contexts";
import { useContext } from "react";
import moment from 'moment';
import { InfoRow, InfoCell } from "../components";
import './index.scss';

export const EndorsementChainModal = ({ open, onCancel }) => {
    const { endorsementChain } = useContext(DocumentsContext);
    const { wallets } = useContext(ActiveShipmentsContext);

    const findWalletName = (address) => {
        let wallet = wallets.find(wallet => wallet?.encWallet?.address.toLowerCase() === address);
        if (wallet) {
            return `(${wallet.accountName})`;
        } else {
            return "";
        }
    }

    return (
        <Modal
            className="tr__EndorsementChainModal"
            open={open}
            title="Endorsement chain"
            onCancel={onCancel}
        >
            <div className="content">
                <div className="item_no_owner">
                    {endorsementChain?.map((item, index) => {
                        return (
                            <InfoRow key={index} className="infoRow">
                                <div className="d-flex justify-content-between align-items-center">
                                    <InfoCell className="col-sm-6">
                                            <p className="f-medium">{item?.operation}</p>
                                            <div className="f-medium role">Owner account</div>
                                            <div className="id_account">{item?.currentOwner ? item?.currentOwner : '-----'}</div>
                                            <div className="org f-medium">{findWalletName(item?.currentOwner)}</div>
                                    </InfoCell>
                                    <InfoCell className="col-sm-6">
                                            <p className="f-medium time">{moment(item.updatedAt).format('DD MMMM YYYY, HH:mm A')}</p>
                                            <div className="f-medium role">Holder account</div>
                                            <div className="id_account">{item?.currentHolder ? item?.currentHolder : '-----'}</div>
                                            <div className="org f-medium">{findWalletName(item?.currentHolder)}</div>
                                    </InfoCell>
                                </div>
                            </InfoRow>
                        )
                    })}
                </div>
            </div>

        </Modal>
    )
}